const name: any = {
	name: '東大辉',
	credit1: '金币',
	credit2: '银币',
	credit3: '股权',
	credit4: '认购次数',
};
export default name;
